<template>
  <div>
    <el-dialog
      :title='dialogTitle'
      :visible.sync='dialogVisible'
      :width='dialogWith'
      center
      @close='dialogClose'>
      <el-tabs v-model='activeName'>
        <el-tab-pane label='基础信息' name='information'>
          <div class='information'>
            <el-form :model='informationData' label-position='right'
                     :rules='rules' ref='ruleForm' label-width='130px'>
              <el-form-item label='供应商：' prop='supplier'>
                <el-input size='mini' placeholder='请输入委托商' v-model='informationData.supplier'
                          style='width: 90%;' />
              </el-form-item>
              <div style='position: absolute;left: 320px;top: 11px;'>
                <i v-if='informationData.supplier !== oldSupplier' class='el-icon-warning icon'
                   :title='oldSupplier' />
              </div>
              <el-row>
                <el-col :span='8'>
                  <el-form-item label='含税合同价：'>
                    {{ informationData.sumIncluded }}
                  </el-form-item>
                </el-col>
                <el-col :span='8'>
                  <el-form-item label='含税预结算价：'>
                    {{ informationData.sumNotIncluded }}
                  </el-form-item>
                </el-col>
                <el-col :span='8'>
                  <el-form-item label='差价：'>
                    {{ informationData.difPrice }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label='标题：' prop='title'>
                <el-input size='mini' placeholder='请输入对账单标题' v-model='informationData.title'
                          style='width: 90%;' />
              </el-form-item>
              <el-form-item label='备注：'>
                <el-input size='mini' placeholder='请输入备注' :autosize='{ minRows: 5, maxRows: 10}'
                          v-model='informationData.remark' style='width:90% '
                          type='textarea' />
              </el-form-item>
              <el-form-item style='margin-left: 80px'>
                <el-button type='primary' size='mini' @click='dialogSubmit'>确认</el-button>
                <el-button type='info' size='mini' @click='dialogClose'>取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <!-- 运单信息 -->
        <el-tab-pane label='运单信息' name='cost'>
          <div class='cost' style='padding: 0 10px 20px'>
            <div class='operation'>
              <div class='total' style='margin-left: 35px'>
                <el-row style='margin-bottom: 10px'>
                  <el-col :span='8' style='font-size: 14px;color: #606266;font-weight: 700;'>
                    含税合同价:{{ sumContract }}
                  </el-col>
                  <el-col :span='8' style='font-size: 14px;color: #606266;font-weight: 700;'>
                    含税预结算价:{{ sumNotIncluded }}
                  </el-col>
                  <el-col :span='8' style='font-size: 14px;color: #606266;font-weight: 700;'>
                    差价:{{ difPrice }}
                  </el-col>
                </el-row>
              </div>
              <div class='operationTitle' v-if='importShow'>
                <div class='line' />
                <span>已选择运单</span>
              </div>
              <div class='operationTable'>
                <el-table
                  v-loading='tableLoading'
                  :data='tableData'
                  style='width: 100%'
                  border
                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                >
                  <el-table-column label='结算类型' prop='settlementType' align='center'
                                   :formatter='settlementTypeFormat' />
                  <el-table-column label='港口/库房名称' prop='name' align='center' />
                  <el-table-column label='台账月' prop='standingBookMonth' align='center' />
                  <el-table-column label='作业时间' prop='taskDate' align='center' />
                  <el-table-column label='品牌' prop='brand' align='center' />
                  <el-table-column label='作业类型' prop='taskType' align='center' />
                  <el-table-column label='作业数量' prop='taskNum' align='center' />
                  <el-table-column label='结算方式' prop='settlementStyle' align='center'
                                   :formatter='settlementStyleFormat' />
                  <el-table-column label='税率（%）' prop='taxRate' align='center' />
                  <el-table-column prop='taxContractPrice' label='含税合同价' align='center' />
                  <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center' />
                  <el-table-column label='操作' align='center'>
                    <template slot-scope='scope'>
                      <div class='iconError'>
                        <!-- 1 为运单费用-->
                        <i class='el-icon-error' @click='deleteClick(scope.$index,1)'></i>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
              <div class='operationTitle' v-if='importShow'>
                <div class='line' />
                <span>未选择运单</span>
              </div>
              <div class='operationTable' v-if='importShow'>
                <el-table
                  v-loading='tableLoading'
                  :data='notTableData'
                  style='width: 80%'
                  border
                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                >
                  <el-table-column type='index' label='序号' align='center' width='50px' />
                  <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center' />
                  <el-table-column prop='waybillNo' label='运单号' min-width='120' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='brandName' label='品牌' align='center' />
                  <el-table-column prop='modelName' label='型号' align='center' />
                  <el-table-column prop='departurePort' label='起始地' min-width='150' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='arrivePort' label='交车地' min-width='150' align='center'
                                   show-overflow-tooltip />
                  <el-table-column prop='standingBookMonth' label='台账月' min-width='100'
                                   align='center' />
                  <el-table-column prop='taxContractPrice' label='含税合同价' align='center' />
                  <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center' />
                  <el-table-column label='操作' align='center'>
                    <template slot-scope='scope'>
                      <el-button size='mini' type='primary' @click='addWaybill(scope.$index)'>添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import OtherAdd from '@/views/settle/supplier/components/otherAdd.vue';
import { customerAdd, deductionInvoicingCostGetAllByCompanyId } from '@/service/getData';

export default {
  name: 'generateStatement',
  components: { OtherAdd },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '生成对账单',
      dialogWith: '950px',
      activeName: 'information',
      InvoicingList: [], // 选择抵扣费用 下拉
      informationData: {
        supplier: '', // 供应商
        sumIncluded: '', // 含税合同价
        sumNotIncluded: '', // 含税预结算价
        difPrice: '', // 差价
        title: '',
        remark: '',
      },
      oldSupplier: '',
      sumContract: 0, // 含税合同价
      sumNotIncluded: 0, // 含税预结算价
      difPrice: 0,//差价
      otherIncluded: '', // 合计含税费用
      otherNotIncluded: '', // 合计不含税费用
      importShow: '', // 是否导入
      tableData: [],
      notTableData: [],
      otherTableData: [],
      tableLoading: false,
      otherAddFlag: false,
      isDisabled: false,
      consignorId: '',
      rules: {
        title: {
          required: true,
          message: '请输入对账单标题',
          trigger: 'blur',
        },
        isInvoicing: {
          required: true,
          message: '请选择是否抵扣开票',
          trigger: 'blur',
        },
        instruction: {
          required: true,
          message: '请选择抵扣费用数据',
          trigger: 'blur',
        },
        Deductible: {
          required: true,
          message: '请输入抵扣费用',
          trigger: 'blur',
        },
        IsoilPrice: {
          required: true,
          message: '请选择是否启用油价',
          trigger: 'blur',
        },
      },
    };
  },
  watch: {
    // 监听已选择运单
    tableData(newVal) {
      // 含税合同价
      this.sumContract = this.calculation(newVal, 'taxContractPrice');
      // 含税预结算价
      this.sumNotIncluded = this.calculation(newVal, 'taxPreparePrice');
     //差价
      this.difPrice = this.calculation(newVal,'difPrice')
      // 保存原始供应商
      this.informationData.supplier = this.oldSupplier = newVal.length > 0 ? newVal[0].supplierName : '';
    },
  },
  methods: {
    // 结算类型格式化
    settlementTypeFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '库房';
        case 1:
          return '港口';
      }
    },
    // 结算方式格式化
    settlementStyleFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '预结算价';
        case 1:
          return '合同价';
      }
    },
    // flag 1 运单费用 2 其他费用 删除
    deleteClick(index, flag) {
      if (flag === 1) {
        const array = this.tableData.splice(index, 1);

        array.forEach((item) => {
          this.notTableData.push(item);
        });

        // 已选选择运单费用  触发父组件  将数据传给父组件重新回显勾选
        this.$emit('selectionTable', this.tableData);
      } else {
        this.otherTableData.splice(index, 1);
        // 触发子组件 其他费用添加  联动多选表格，重新勾选
        this.$refs.otherAdds.toggleSelection();
      }
    },
    dialogOpen(selectedData) {
      this.tableData = selectedData;
      this.informationData.sumIncluded = this.calculation(this.tableData, 'taxContractPrice');
      this.informationData.sumNotIncluded = this.calculation(this.tableData, 'taxPreparePrice');
      this.informationData.difPrice = this.calculation(this.tableData,'difPrice')
      this.sumContract = this.calculation(this.tableData, 'taxContractPrice');
      this.sumNotIncluded = this.calculation(this.tableData, 'taxPreparePrice');
      this.difPrice = this.calculation(this.tableData,'difPrice')
      // 保存原始供应商   判断是否为空
      this.informationData.supplier = this.oldSupplier = this.tableData.length > 0 ? this.tableData[0].supplierName : '';
      this.consignorId = this.tableData.length > 0 ? this.tableData[0].supplierId : '';
      this.dialogVisible = true;
    },
    // 合计 费用
    sumCost() {
      // 合计含税费用
      this.informationData.sumIncluded = (Number(this.sumContract) + Number(this.otherIncluded))
        .toFixed(2);
      // 合计不含税费用
      this.informationData.sumNotIncluded = (Number(this.sumNotIncluded) + Number(this.otherNotIncluded))
        .toFixed(2);
    },
    /**
     * 计算
     * @param table 传入数据
     * @param field 计算数据对应的字段
     * @returns {string} 返回计算好的值（含两位小数）
     */
    calculation(table, field) {
      let sum = 0;
      table.forEach((item) => {
        sum += Number(item[field]);
      });
      return sum.toFixed(2);
    },
    //  判断 不/含税合同价是否为空  value运单费用  value2其他费用
    decideContract(value, value2) {
      let flag = true;
      // 判断 作业费用
      for (const valueKey of value) {
        if (valueKey.taxContractPrice === null || valueKey.contractPrice === null) {
          // 是否禁用选项
          this.isDisabled = true;
          flag = false;
          console.log(this.isDisabled);
          // this.informationData.Settlement = 2;
          this.settlement = 2;
          break;
        } else {
          flag = true;
        }
      }
      for (const value2Element of value2) {
        if (value2Element.included === null || value2Element.notIncluded === null) {
          // 是否禁用选项
          this.isDisabled = true;
          flag = false;
          console.log(this.isDisabled);
          // this.informationData.Settlement = 2
          this.settlement = 2;
          break;
        } else {
          flag = true;
        }
      }
      if (flag) {
        this.isDisabled = false;
      }
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    // 是否抵扣开票
    isInvoicingChange(value) {
      const id = this.tableData.length > 0 ? this.tableData[0].consignorId : '';
      if (value === 1) {
        this._deductionInvoicingCostGetAllByCompanyId(id);
      }
    },
    // 获取最大抵扣金额
    async _deductionInvoicingCostGetAllByCompanyId(id) {
      const res = await deductionInvoicingCostGetAllByCompanyId(id);
      if (res.status !== 0) return this.$message.warning(res.message);
      this.informationData.remainingDiscountAmount = res.data[0].remainingDiscountAmount;
      this.InvoicingList = res.data.map(item => ({
        id: item.id,
        deductionNum: item.instruction,
        remainingDiscountAmount: item.remainingDiscountAmount,
      }));
    },
    dialogSubmit() {
      if (this.tableData.length <= 0) return this.$message.warning('作业费用不能为空');
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          await this.customerAdd();
        }
      });
    },
    async customerAdd() {
      const {
        supplier,
        sumIncluded,
        sumNotIncluded,
        title,
        remark,
      } = this.informationData;
      // let settIds = '';
      // this.tableData.forEach((item, index) => {
      //   // 最后一个不加逗号
      //   settIds += index === this.tableData.length - 1 ? item.id : `${item.id},`;
      // });
      const settIds = this.tableData.map(item => item.id)
        .join(',');
      const otherCostIds = this.otherTableData.map(item => item.id)
        .join(',');
      // let otherCostIds = '';
      // this.otherTableData.forEach((item, index) => {
      //   // 最后一个不加逗号
      //   otherCostIds += index === this.otherTableData.length - 1 ? item.id : `${item.id},`;
      // });
      const obj = {
        companyId: this.consignorId,
        companyNameOld: this.oldSupplier,
        companyNameNew: supplier,
        taxPrice: parseFloat(sumIncluded),
        noTaxPrice: parseFloat(sumNotIncluded),
        title,
        remark,
        type: 27, // 委托商港口费生成对账单结算
        settIds: this.tableData.length > 0 ? settIds : '',
        otherCostIds: this.otherTableData.length > 0 ? otherCostIds : '',

        settType: 1,
      };
      const res = await customerAdd(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.dialogClose();
      this.$emit('clearSelectedData');
    },
    // 未选择运单费用 操作添加 添加到已选择运单费用
    addWaybill(index) {
      const a = this.notTableData.splice(index, 1);
      this.tableData.push(a[0]);
      // 已选选择运单费用  触发父组件  将数据传给父组件重新回显勾选
      this.$emit('selectionTable', this.tableData);
    },
    async otherAddClick() {
      this.consignorId = this.tableData.length > 0 ? this.tableData[0].consignorId : '';
      this.otherAddFlag = true;
      this.$nextTick(() => {
        this.$refs.otherAdds._othercostGetAllByCompanyId();
      });
    },
    otherData(value) {
      this.otherTableData = value;
    },
  },
};
</script>

<style scoped>

</style>
